import { Stack } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { MaterialIcon } from '@components';

interface PaginationProps {
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  isFetching: boolean;
  onNextPage: () => void;
  onPreviousPage: () => void;
}

export default function SimplePagination({
  hasPreviousPage,
  hasNextPage,
  isFetching,
  onNextPage,
  onPreviousPage,
}: PaginationProps) {
  return (
    <Stack
      direction="row"
      justifyContent={hasPreviousPage ? 'space-between' : 'flex-end'}
      alignItems="center"
      spacing={2}
    >
      {hasPreviousPage && (
        <LoadingButton startIcon={<MaterialIcon symbol="arrow_back" />} onClick={onPreviousPage} loading={isFetching}>
          Previous Page
        </LoadingButton>
      )}
      {hasNextPage && (
        <LoadingButton endIcon={<MaterialIcon symbol="arrow_forward" />} onClick={onNextPage} loading={isFetching}>
          Next Page
        </LoadingButton>
      )}
    </Stack>
  );
}
